export default __webpack_public_path__ + "static/media/warning--slow--g1.5f3c1df0.png";